import React from 'react';

import AppText from './AppText';
import { color as themeColor } from 'ui';

type Props = {
  color?: string;
  name: string;
};

const PageTitle = ({ name, color }: Props) => {
  return (
    <AppText
      color={color ? color : themeColor.black}
      weight="600"
      size="24px"
      bottom="1rem"
      display="block"
    >
      {name}
    </AppText>
  );
};

export default PageTitle;
